import React, { useEffect } from "react";
import { decoded } from "../Utils/UserProfile";
import { useNavigate } from "react-router";
import PageDataViewData from "../components/PageDataViewData";

const PageDataView = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (decoded === null) {
      window.location.href = "/";
    }
  }, [decoded]);
  return (
    <div className="innerContainer">
      <div className="dashboardPage">
        <PageDataViewData />
      </div>
    </div>
  );
};

export default PageDataView;
